import React, { Component } from 'react'
import { connect } from 'react-redux'
import HelpText from '../tags/HelpText'
import Loading from '../tags/Loading'
import parse from 'html-react-parser';

import { getProperty } from '../../helpers/properties'
import { withRouter } from 'react-router-dom'

import { getSoneFundingByCourseSSPNo, getStudentProgress } from '../../services/vu'
import { getFinanceSupportContent, getFinanceSupportLeadText } from '../../services/reservoir'
import { getFinancialContentErrorMessage } from '../../helpers/financialSupport';
import { getConfiguration } from '../../helpers/configuration'

import ResidencyType from '../../enums/ResidencyType'

import { FinancialSupportCard } from '../tags/financialSupport/cards/FinancialSupportCard'

const mapStateToProps = ({ courses: { selectedCourseCode, data }, course: { selectedCourse }, personalDetails }) => {
  return {
    course: selectedCourse,
    courseAttemptStatus: selectedCourse.courseAttemptStatus,
    isCommencing: selectedCourse.isCommencing,
    courseCode: selectedCourseCode,
    courseTitle: selectedCourse.courseTitle,
    courseIsSelfManagedEnrolCourse: selectedCourse.isSelfManagedCourse,
    courseSspCensusDate: selectedCourse.sspCensusDate,
    courseSSPNo: selectedCourse.courseSSPNo,
    courseLiabilityCategoryCode: selectedCourse.liabilityCategoryCode,
    courseStage: selectedCourse.courseStage,
    courseStatus: selectedCourse.courseStatus,
    admissionCategory: selectedCourse.admissionCategory,
    personalDetails: personalDetails.data
  }
}

class FinancialSupport extends Component {
  constructor(props) {
    super(props)

    this.state = {
      loadingProgress: true,
      loadingError: false,
      completedInitialOnboarding: false,
      isInternationalStudent: false,
      fundingInfo: [],
      hasSubmittedGAF: false,
      inegibilityContent: null,
      hasContentError: false,
      hasLeadText: false,
      leadText: ""
    }
  }

  componentDidMount() {
    Promise.all([
      getStudentProgress(this.props.courseCode),
      getSoneFundingByCourseSSPNo(this.props.courseSSPNo, this.props.courseLiabilityCategoryCode, this.props.personalDetails.stuCitizenCd)
    ])
      .then(([progress, fundingInfo]) => {

        let setStateJson = {
            loadingProgress: false,
            loadingError: false,
            completedInitialOnboarding: !!progress && progress.navigationSteps && progress.navigationSteps.every(step => !step.disabled),
            fundingInfo: fundingInfo,
            hasSubmittedGAF:
              fundingInfo &&
              fundingInfo.potentialFundingType &&
              fundingInfo.potentialFundingType.filter(fundingType => fundingType.status === '$APR' || fundingType.status === '$SUB' || fundingType.status === '$GOV').length > 0,
            isInternationalStudent: this.props.personalDetails ? ResidencyType.International.includes(this.props.personalDetails.stuCitizenCd) : this.state.isInternationalStudent
        }

        getFinanceSupportLeadText(fundingInfo, this.props.admissionCategory)
        .then(fsLeadtextContent => {
          let bodyContent = "";
          let hasLeadText= false;

          if (Array.isArray(fsLeadtextContent) && fsLeadtextContent.length !== 0) {
            bodyContent = fsLeadtextContent[0].attributes.body.value.replace("{courseTitle}", this.props.course.courseTitle).replace("{courseCode}", this.props.course.courseCode)
            hasLeadText = true;
          }

          this.setState(
            {
              ...setStateJson,
              hasLeadText: hasLeadText,
              leadText: bodyContent
            }, () => {
              if(this.isNotAbleToAccessFunding() && this.props.admissionCategory === 'TAFE') {
                let vetFunding = {
                  "potentialFundingType": {
                    "fundingType": "VET-HELP",
                    "status": "INELIGIBLE"
                  }
                }
                this.getFinancialSupportContent(vetFunding)
              }
            }
          )
        })
        .catch((error) => {
          this.setState(
            {
              ...setStateJson
            }, () => {
              if(this.isNotAbleToAccessFunding() && this.props.admissionCategory === 'TAFE') {
                let vetFunding = {
                  "potentialFundingType": {
                    "fundingType": "VET-HELP",
                    "status": "INELIGIBLE"
                  }
                }
                this.getFinancialSupportContent(vetFunding)
              }
            }
          )
        })
      })
      .catch((error) => {
        this.setState({
          loadingProgress: false,
          loadingError: true
        })
        this.props.history.push(getConfiguration('baseUrl'))
      })
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.props.personalDetails && !prevProps.personalDetails) {
      this.setState({
        isInternationalStudent: ResidencyType.International.includes(this.props.personalDetails.stuCitizenCd)
      })
    }
  }

  getEditQueryParams = url => {
    return `${url}?courseCode=${this.props.courseCode}`
  }

  getPrintPreviewQueryParams = url => {
    return `${this.getEditQueryParams(url)}&printPreview=true`
  }

  getFinancialSupportContent = (funding) => {
    getFinanceSupportContent(funding.potentialFundingType, true, this.props.personalDetails.stuCitizenCd, this.props.course.liabilityCategoryCode, this.props.course)
    .then((content) => {
      this.setState({
          inegibilityContent: content[0].attributes.body.value,
      });
    }).catch(error => {
      this.setState({
        hasContentError: true
      })
    });
  }

  handleErrorOnContent = () => {
    this.setState({
      hasContentError: true
    })
  }

  mustCompleteInitialOnboarding = () => {
    const commencingStudent = this.props.isCommencing
    return commencingStudent && !this.state.completedInitialOnboarding && this.props.courseIsSelfManagedEnrolCourse
  }

  isNotAbleToAccessFunding = () => {
    return (
      ResidencyType.International.includes(this.props.personalDetails.stuCitizenCd) ||
      this.props.courseStage !== 'ADM' ||
      (this.props.courseStage === 'ADM' && (this.props.courseStatus !== 'ADM' && this.props.courseStatus !== 'POTC')) ||
      this.state.fundingInfo.potentialFundingType.length === 0
    )
  }

  mustCompleteFinancialSupport = () => {
    return (this.props.isCommencing && !this.props.courseIsSelfManagedEnrolCourse && !this.state.hasSubmittedGAF) || (!this.props.isCommencing && !this.state.hasSubmittedGAF)
  }

  renderCards = () => {
    if (this.isNotAbleToAccessFunding()) {
      return this.props.admissionCategory === 'TAFE' && this.state.inegibilityContent ? (
        <div className='financial-info'>
          <div className='lead'>
              Unfortunately, you are not eligible to apply for a VET Student Loan (VSL) for {' '}
              <b>
              {this.props.courseTitle} [{this.props.courseCode}]
              </b>
          </div>

          {parse(this.state.inegibilityContent)}
        </div>
      ) : (
        <div className="sidenote sidenote--fyi">
          <div className="sidenote__content center-xs">
            <p>
              <strong>
                You are currently not eligible for financial support. Please <a href="https://www.vu.edu.au/contact-us/vuhq-student-service-centres">contact VUHQ</a> if you require further
                information.
              </strong>
            </p>
          </div>
        </div>
      )
    }

    if (this.mustCompleteInitialOnboarding()) {
      return (
        <div className="sidenote sidenote--warning">
          <div className="sidenote__content center-xs">
            <p>
              <strong>Please complete your enrolment to access your financial support</strong>
            </p>
            <div className="row">
              <div className="col-xs-12 center-xs">
                <a className="btn btn-lg btn-primary btn-enrol" href={`${getProperty('enrolUrl')}?courseId=${this.props.courseCode}`}>
                  Complete enrolment
                </a>
              </div>
            </div>
          </div>
        </div>
      )
    }

    if (this.state.hasContentError) return getFinancialContentErrorMessage();

    return (
      <div>
        {/* {this.state.fundingInfo.potentialFundingType.length && this.props.admissionCategory !== 'TAFE' && (
          <p className={'lead'}>
            You are eligible for the following Government HELP loans for{' '}
            <b>
              {this.props.courseTitle} [{this.props.courseCode}]
            </b>
          </p>
        )}  */}
        {
          this.state.hasLeadText && parse(this.state.leadText)
        }

        {
          this.state.fundingInfo.potentialFundingType.length && this.state.fundingInfo.potentialFundingType.map((fundingInfo, index) => {
            return <FinancialSupportCard key={index} fundingInfo={fundingInfo} citizenCode={this.props.personalDetails.stuCitizenCd} course={this.props.course} courseLiabilityCategoryCode={this.props.courseLiabilityCategoryCode} handleError={this.handleErrorOnContent}/>;
          })
        } 
      </div>
    )
  }

  render() {
     return this.state.loadingError ? (
      <div>
        <HelpText
          tag={'h1'}
          text={'Financial Support'}
          toolTip={
            <span>
              <b>Note:</b> If you are studying more than one course at the same time, click on the hamburger menu in the top left to change your course.
            </span>
          }
        />
        <div className="sidenote sidenote--fyi">
          <div className="sidenote__content center-xs">
            <p>
              <strong>
                Failed to retrieve financial support information.
              </strong>
            </p>
          </div>
        </div>
      </div>
     ) : (
      <div>
        <HelpText
          tag={'h1'}
          text={'Financial Support'}
          toolTip={
            <span>
              <b>Note:</b> If you are studying more than one course at the same time, click on the hamburger menu in the top left to change your course.
            </span>
          }
        />
        {this.state.loadingProgress ? <Loading /> : this.renderCards()}
      </div>
    )
  }
}

export default withRouter(connect(mapStateToProps)(FinancialSupport))
